import { Component, Input, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from 'src/store';
import { Observable, Subscription } from 'rxjs';
import { PTO } from 'src/store/workspace/workspace.model';


@Component({
  selector: 'app-paidtimeoff',
  templateUrl: './paidTimeOff.component.html',
  styleUrls: ['./paidTimeOff.component.scss'],
})
export class PaidTimeOffComponent {
  @ViewChild('paidtimeoff', {static: false}) paidtimeoff: HTMLDivElement;
  @Input() paidTimeOff: PTO;

  paidTimeOff$: Observable<PTO>;
  convertedPTOSub: Subscription;
  convertedPTO: PTO;

  public displayPTOInHours: boolean = false;

  public isW2Employee: boolean = false;

  constructor(private store: Store<fromRoot.AppState>) {
    this.paidTimeOff$ = this.store.select(state => state.workspace.paidTimeOff);
    this.convertedPTOSub = this.paidTimeOff$.subscribe(pto => {
      if (pto) { 
        this.convertedPTO = this.convertHoursToDays(pto);
        this.isW2Employee = pto.isViewable !== false;
      } 
    });
  }
  
  public convertHoursToDays(pto: PTO): PTO {
    const workHoursPerDay = 8;
    const timeOffAllowedDays = pto.timeOffAllowed / workHoursPerDay;
    const timeOffUsedDays = pto.timeOffUsed / workHoursPerDay;
    const timeOffRemainingDays = pto.timeOffRemaining / workHoursPerDay;

    return {
      ...pto,
      timeOffAllowed: timeOffAllowedDays,
      timeOffUsed: timeOffUsedDays,
      timeOffRemaining: timeOffRemainingDays
    };
  }

  public togglePTODisplay() {
    this.displayPTOInHours = !this.displayPTOInHours;
  }
}
